// extracted by mini-css-extract-plugin
export default {"container":"style_container__9LMzN","section":"style_section__nOucX","ssection":"style_ssection__MKy2-"};